<template>
    <div>
        <swiper
            ref="mySwiper"
            :options="swiperOptions"
            v-if="aboutCoverPath.length != 0"
        >
            <swiper-slide v-for="(item, index) in aboutCoverPath" :key="index">
                <img :src="item" class="cover"/>
            </swiper-slide>
            <div
                class="swiper-pagination swiper-pagination-white"
                slot="pagination"
            ></div>
        </swiper>
        <v-container>
            <div class="block-title">{{ $t("about.name") }}</div>
            <div v-html="storeInfo.about"></div>
            <div class="block-title">{{ $t("about.location") }}</div>
            <GmapMap style="width: 100%; height: 350px;" :zoom="14" :center="center">
                <GmapMarker label="★" :position="center"/>
            </GmapMap>
        </v-container>
    </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
    data() {
        return {
            center: {},
            swiperOptions: {
                loop: true,
                speed: 300,
                autoHeight: true,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            }
        };
    },

    created() {
        this.getStoreInfo();
        this.center = {
            lat: parseFloat(this.storeInfo.address.latitude),
            lng: parseFloat(this.storeInfo.address.longitude)
        };
    },
    computed: {
        ...mapState(["storeInfo"]),

        aboutCoverPath() {
            if (this.storeInfo && this.storeInfo.aboutCoverPath && this.storeInfo.aboutCoverPath.length) {
                return this.storeInfo.aboutCoverPath.split(",");
            } else {
                return [];
            }
        }
    },

    methods: {
        ...mapActions(["getStoreInfo"])
    }
};
</script>

<style scoped lang="sass" src="./about-us.sass"></style>
